import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'edcom-ui';
import styles from './FilterChips.module.less';

export default function FilterChips({ filters, clickFilterChip }) {
  const renderFilterChips = filters.map((element, i) => {
    const title =
      element.group !== 'q'
        ? `Remove filter: ${element.display.toUpperCase()}`
        : 'Remove search term';
    const displayName = element.display;
    const remove = () => clickFilterChip(element.href);

    return (
      <div
        className={styles.chip}
        title={title}
        onClick={remove}
        key={`remove-filter-${i}`}
        role="link"
      >
        {displayName}
        <Icon name="cancel-circled" />
      </div>
    );
  });

  return <>{renderFilterChips}</>;
}

FilterChips.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      display: PropTypes.string,
      group: PropTypes.string,
      href: PropTypes.string,
    })
  ).isRequired,
  clickFilterChip: PropTypes.func,
};
